import { Stack } from '@mui/material';
import React from 'react';
import POSHeading from './POSHeading';

export type POSBadgeVariant = 'neutral' | 'secondary' | 'error' | 'info' | 'success' | string;

interface Props {
    text: string;
    fontSize?: string | number;
    fontColor?: string;
    fontWeight?: number;
    startDate?: string;
    badgeText?: string;
    onClick?: () => void;
    condition?: boolean;
    variant?: POSBadgeVariant;
}

const variantStyles: Record<string, { backgroundColor: string; fontColor: string; borderColor: string }> = {
    neutral: { backgroundColor: '#f5f5f5', fontColor: '#616161', borderColor: '#e0e0e0' },
    secondary: { backgroundColor: '#f0f4f8', fontColor: '#475569', borderColor: '#cbd5e1' },
    error: { backgroundColor: '#fde8e8', fontColor: '#9b1c1c', borderColor: '#fbd5d5' },
    info: { backgroundColor: '#e1f5fe', fontColor: '#0288d1', borderColor: '#b3e5fc' },
    success: { backgroundColor: '#def7ec', fontColor: '#03543f', borderColor: '#bcf0da' },
};

const POSBadge = ({
    text,
    fontSize = 15,
    fontColor,
    fontWeight = 400,
    // startDate,
    badgeText,
    onClick,
    condition = false,
    variant,
}: Props) => {
    const selectedVariantStyle = variant ? variantStyles[variant] : undefined;
    const resolvedFontColor = fontColor || selectedVariantStyle?.fontColor || 'gray';
    const resolvedBackgroundColor = selectedVariantStyle?.backgroundColor || '#fff';
    const resolvedBorderColor = selectedVariantStyle?.borderColor || '#eee';

    return (
        <Stack>
            <Stack
                sx={{
                    p: 2,
                    backgroundColor: resolvedBackgroundColor,
                    boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.1)',
                    width: 'auto',
                    py: 1,
                    borderRadius: 2,
                    minWidth: 'fit-content',
                    border: `1px solid ${resolvedBorderColor}`,
                }}
            >
                <POSHeading
                    sx={{
                        fontWeight,
                        fontSize,
                        mx: 'auto',
                        my: 'auto',
                        color: resolvedFontColor,
                    }}
                    text={text}
                />
            </Stack>

            {condition && (
                <POSHeading
                    onClick={onClick}
                    sx={{
                        fontWeight: 500,
                        fontSize: 16,
                        my: 'auto',
                        color: '#2e2e2e',
                        mt: 1,

                        textAlign: {
                            xs: 'start',
                            md: 'end',
                        },

                        '&:hover': {
                            cursor: 'pointer',
                        },
                    }}
                    text={badgeText || ''}
                />
            )}
        </Stack>
    );
};

export default POSBadge;
